import Model, { attr } from '@ember-data/model';
import { cached } from '@glimmer/tracking';

export enum SecurityDepositPer {
  booking = 'booking',
  property = 'property',
}

export enum SafeguestStatuses {
  connect = 'connect',
  connected = 'connected',
  pending = 'pending',
}

export default class AccountConfigurationModel extends Model {
  @attr('boolean') defaultAirbnbPriceSyncEnabled!: boolean;
  @attr('number') defaultSecurityDepositAmount!: number;
  @attr('boolean') defaultSecurityDepositEnabled!: boolean;
  @attr('boolean') securityDepositsEnabledUplisting!: boolean;
  @attr('boolean') securityDepositsEnabledBookingDotCom!: boolean;
  @attr('boolean') securityDepositsEnabledGoogle!: boolean;
  @attr('boolean') securityDepositsEnabledHomeaway!: boolean;
  @attr('boolean') securityDepositsEnabledAirbnbOfficial!: boolean;
  @attr('string') securityDepositPer!: SecurityDepositPer;
  @attr('boolean') securityDepositAutoReleaseEnabled!: boolean;
  @attr('number') securityDepositReleaseAfterHours!: number;
  @attr('string') safeguestEmail!: string;
  @attr('string') safeguestStatus!: SafeguestStatuses | null;
  @attr('boolean') safeguestEnabledAirbnbOfficial!: boolean;
  @attr('boolean') safeguestEnabledBookingDotCom!: boolean;
  @attr('boolean') safeguestEnabledHomeaway!: boolean;
  @attr('boolean') safeguestEnabledUplisting!: boolean;
  @attr('boolean') safeguestEnabledGoogle!: boolean;
  @attr('boolean') contactFormEnabledAirbnbOfficial!: boolean;
  @attr('boolean') contactFormEnabledBookingDotCom!: boolean;
  @attr('boolean') contactFormEnabledHomeaway!: boolean;
  @attr('boolean') contactFormEnabledUplisting!: boolean;
  @attr('boolean') contactFormEnabledGoogle!: boolean;
  @attr('boolean') automatedReviewsEnabled!: boolean;
  @attr('number') automatedReviewsDelay!: number;
  @attr('string') displayName!: string;
  @attr('boolean') bookingDotComPaymentsEnabled!: boolean;
  @attr('number') bookingDotComCommissionTaxPercentage!: number | null;
  @attr('number') lockCodeLength!: number;
  @attr('boolean') clientManagementEnabled!: boolean;
  @attr('boolean') clientStatementsEnabled!: boolean;
  @attr('string') timezone!: string;
  @attr('number', { defaultValue: 0 }) smartLockCheckInBuffer!: number;
  @attr('number', { defaultValue: 0 }) smartLockCheckOutBuffer!: number;
  @attr('number') taskNotifyAfterMinutes!: number | null;
  @attr('number') taskReassignAfterMinutes!: number | null;
  @attr('number') taskUnclaimedAlertLeadHours!: number | null;

  @cached
  get safeguestConnected(): boolean {
    return this.safeguestStatus === SafeguestStatuses.connected;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'account-configuration': AccountConfigurationModel;
  }
}
